<template lang="pug">
    header.header.grey.lighten-5( ref="header" )
        div.header__container.grey.lighten-5( :class="{ 'header__container--fixed': fixed }" )
            v-container
                v-row( no-gutters align="center" )
                    v-col( cols="12" ) 
                        h1 ControllerVibe
                        navigation
                        controller-detection.header__detect
    //-                 v-col( cols="12" lg="2" md="2" sm="2" xs="4" )
                            v-img( :src="require('@/assets/logo.png')" )
    //-                 v-col( cols="12" lg="6" md="5" sm="4" xs="4" )
                            navigation
    //-                 v-col( cols="12" lg="4" md="5" sm="6" xs="8" )
                            controller-detection
</template>

<script>
    import Navigation from '@/components/Navigation';
    import ControllerDetection from '@/components/ControllerDetection';

    export default {
        name: "HeaderBar",
        components: {
            Navigation,
            ControllerDetection
        },
        data() {
            return {
                fixed: true
            }
        },
        mounted() {
            this.fixHeader();
            this.scroll();
        },
        methods: {
            fixHeader() { 
                // this.fixed = this.$refs.header ? window.scrollY > this.$refs.header.offsetTop : false;
            },
            scroll() {
                window.onscroll = () => {
                    this.fixHeader();
                }
            }
        }
    }
</script>

<style scoped lang="scss">

    $module-height: 108px;

    .header {
        position: relative;
        width: 100%;
        height: $module-height;
        padding-bottom: $module-height;

        &__container {
            position: absolute;
            width: 100%;
            height: 100%;
            box-shadow: 0px 20px 20px #fafafa; // rgba(0,0,0,0.15);
            overflow: auto;
            z-index: 99;

            &--fixed {
                position: fixed;
                width: 100%;
                height: $module-height;
                top: 0;
            }
        }

        &__detect {
            display: none;
        }

        .container {
            height: 100%;

            .row {
                height: 100%;
            }
        }
    }
</style>